import cx from 'classnames';

import { t } from '../../common/i18n';
import { IssueStatus } from '../types';

const namespace = 'Issues';

interface IssueStatusBadgeProps {
  status: IssueStatus;
  className?: string;
}

export const IssueStatusBadge: React.FC<IssueStatusBadgeProps> = ({ status, className }) => (
  <span className={cx('IssueBadge', `IssueBadge--${status}`, className)}>{t(`status.${status}`, namespace)}</span>
);

export default IssueStatusBadge;
